<template>
	<DsHcSingleChoice
		:name="state.currentQuestion.questionBlockId"
		:legend="state.currentQuestion.questionText"
		:description="state.currentQuestion.subText"
		:options="options"
		:validationMessage="state.currentQuestion.validationMessageText"
		:invalid="state.currentQuestion.isTouched && !state.currentQuestion.isValid"
		:columns="columns"
		:startLabel="state.currentQuestion.startLabelText"
		:endLabel="state.currentQuestion.endLabelText"
		:modelValue="state.answersByQuestionId[state.currentQuestion.questionBlockId]?.[0]?.value"
		@change="setAnswer"
	></DsHcSingleChoice>
</template>

<script setup>
import { DsHcSingleChoice } from '@coloplast/design-system';
import { useHealthCheckState } from '../useHealthCheckState';

const { state } = useHealthCheckState();
const emit = defineEmits(['setAnswer']);

const setAnswer = (response) => {
	emit('setAnswer', { 
		questionBlockId: state.currentQuestion.questionBlockId,
		answer: state.currentQuestion.options.find(item => item.value === response)
	});
};

const columns = state.currentQuestion.options.some(option => option.image) ? 2 : 1;

const options = state.currentQuestion.options.map((option) => ({
	id: option.answerBlockId,
	label: option.text,
	value: option.value,
	imageSrc: option.image,
	helper: option.tooltipLinkText ? {
		text: option.tooltipLinkText,
		...(option.tooltip && {
			toggletip: {
				buttonLabel: option.tooltipButtonText ?? option.tooltipLinkText,
				text: option.tooltip,
			},
		}),
	} : null,
}));
</script>